import { useQuery } from '@tanstack/react-query'
import { api, unwrapFaqList } from '@astro/api'

const MAX_PER_TYPE = 2

/** GET /faqs — the website sends no `type` filter (all types), then shows at
 * most 2 FAQs per type, normalized to the {q, a} shape FaqItem renders. */
export function useFaqs() {
  const query = useQuery({
    queryKey: ['faqs', 'all'],
    queryFn: () => api.faqs.list(),
    select: (res) => {
      const perType = {}
      const picked = []
      for (const faq of unwrapFaqList(res)) {
        const key = faq.type || 'other'
        if ((perType[key] ?? 0) >= MAX_PER_TYPE) continue
        perType[key] = (perType[key] ?? 0) + 1
        picked.push({ q: faq.question, a: faq.answer })
      }
      return picked
    },
  })
  return {
    faqs: query.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
  }
}
